<br />
<ignite-panel [panelTitle]="['Australian Agency', 'A12']" [panelMenuOptions]="panelMenuOptions">
  <form [formGroup]="form">
    <ignite-password
      id="password"
      label="Password"
      [frmCtrl]="form.get('password')"
      placeholder="Enter a password"
      [errorMessages]="[
        { key: 'required', message: 'Password is required' },
        { key: 'invalidPassword', message: 'Invalid password' }
      ]"
    ></ignite-password>
    <mat-form-field [hideRequiredMarker]="true" appearance="outline">
      <mat-label floatLabel>Outline form field with error and icon</mat-label>
      <input matInput placeholder="pat@example.com" [formControl]="email" class="has-tooltip" required />
      <i class="fal fa-question-circle ignite-field-tooltip" ignitetooltip="abc"></i>
      @if (email.invalid) {
        <mat-error>{{ getErrorMessage() }}</mat-error>
      }
    </mat-form-field>

    <ignite-name
      id="givenNames"
      label="Given Names"
      [nameControl]="form.get('givenNames')"
      placeholder="Enter given names"
      category="given-names"
    ></ignite-name>
    <ignite-name
      id="surname"
      label="Surname"
      [nameControl]="form.get('surname')"
      placeholder="Enter a surname"
      category="surname"
    ></ignite-name>

    <mat-form-field [hideRequiredMarker]="true" appearance="outline">
      <mat-label floatLabel>Notes (text-area)</mat-label>
      <textarea
        matInput
        placeholder="Enter your notes here..."
        cdkTextareaAutosize
        #autosize="cdkTextareaAutosize"
        formControlName="testInput"
        required
      ></textarea>
      <mat-hint>Hint</mat-hint>
      @if (form.get('testInput').hasError('required')) {
        <mat-error>Notes are required</mat-error>
      }
    </mat-form-field>

    <div>
      <ignite-date label="Date of birth" formControlName="dob"></ignite-date>
    </div>

    <div>
      <ignite-duration label="Expiry time" timeUnit="milliseconds" formControlName="expiry"></ignite-duration>
    </div>

    <mat-form-field [hideRequiredMarker]="true" appearance="outline">
      <mat-label floatLabel>Regular date</mat-label>
      <input matInput class="ignite-date-input" formControlName="regularDate" [matDatepicker]="picker" placeholder="Enter a date" />
      <mat-datepicker ignite-date-picker #picker color="primary"></mat-datepicker>
      @if (form.get('regularDate').hasError('required') && !form.get('regularDate').hasError('matDatepickerParse')) {
        <mat-error
          >Date is required</mat-error
          >
        }
        @if (form.get('regularDate').hasError('matDatepickerParse')) {
          <mat-error i18n>Invalid date</mat-error>
        }
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>Basic Select</mat-label>
        <mat-select ignite-select placeholder="pick one">
          @for (food of foods; track food) {
            <mat-option [value]="food.value">
              {{ food.viewValue }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>Basic Select with just one option</mat-label>
        <mat-select ignite-select placeholder="pick one">
          @for (food of buffet; track food) {
            <mat-option [value]="food.value">
              {{ food.viewValue }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>Multi Select</mat-label>
        <mat-select ignite-select multiple placeholder="pick one or more">
          @for (food of foods; track food) {
            <mat-option [value]="food.value">
              {{ food.viewValue }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>

      <div>
        <ignite-auto-complete
          id="id - autocomplete"
          label="Autocomplete for form"
          [selectOptions]="options"
          [frmCtrl]="myControl"
          placeholder="Pick one"
          hint="Hint"
        ></ignite-auto-complete>
      </div>
      <div>
        <ignite-telephone-input
          label="Telephone number"
          placeholder="Telephone input for test takers"
          required="true"
          [countryCallingCodes]="countryCallingCodes"
          formControlName="phone"
          hint="This is your mobile phone number"
        ></ignite-telephone-input>
      </div>

      <ignite-alert>
        <div alert-title>Match found</div>
        <div alert-content>
          This email address is associated with an existing Test Taker account but the chosen date of birth does not match. Please choose a
          different email address or enter in a different date of birth.
        </div>
      </ignite-alert>

      <mat-checkbox formControlName="isActive">Is account active </mat-checkbox>
      <br />

      <mat-label class="ignite-label">Radio buttons - horizontal layout on desktop</mat-label>
      <mat-radio-group class="horizontal-layout" formControlName="radiob">
        @for (food of foods; track food) {
          <mat-radio-button [value]="food.value">
            {{ food.viewValue }}
          </mat-radio-button>
        }
        @if (form.get('radiob').hasError('notSelected')) {
          <mat-error i18n> Required</mat-error>
        }
      </mat-radio-group>

      <mat-label class="ignite-label">Radio buttons - vertical layout</mat-label>
      <mat-radio-group>
        @for (food of foods; track food) {
          <mat-radio-button [value]="food.value">
            {{ food.viewValue }}
          </mat-radio-button>
        }
      </mat-radio-group>
      <br />
      <br />

      <div class="ignite-buttons-container">
        <div class="ignite-buttons">
          <div class="ignite-button-wrapper">
            <button mat-button class="ignite-button" color="primary" (click)="onAdd()">Add New Record</button>
          </div>
          <div class="ignite-button-wrapper">
            <button class="ignite-button" mat-button color="secondary" (click)="onCancel()">Cancel</button>
          </div>
        </div>
        <hr />
      </div>
    </form>
  </ignite-panel>
  <br /><br />
